import { render } from "./index.vue?vue&type=template&id=4a0bef30&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=4a0bef30&lang=scss"

import exportComponent from "/Users/blakebyrnes/Projects/DataLiberationFoundation/ulixee/apps/chromealive-extension/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__